var map = {
	"./bounce/blocks": 2210,
	"./calc/blocks": 2211,
	"./craft/agent/blocks": 2213,
	"./craft/code-connection/blocks": 2214,
	"./craft/designer/blocks": 2075,
	"./craft/simple/blocks": 2212,
	"./dance/blocks": 1660,
	"./eval/blocks": 2215,
	"./flappy/blocks": 2216,
	"./jigsaw/blocks": 2222,
	"./maze/blocks": 2223,
	"./p5lab/spritelab/blocks": 1248,
	"./sites/studio/pages/blocks": 2237,
	"./studio/blocks": 2083,
	"./turtle/blocks": 2233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2666;